// extracted by mini-css-extract-plugin
module.exports = {"chatSpacing":"chatlink_chatSpacing__ETclg"};